<template>
  <div class="TamizajeCuestionario">
    <md-card>
      <md-card-header>
        <div class="md-title">{{`${paciente.nombre_pac} ${paciente.ape_pat_pac} ${paciente.ape_mat_pac}`}}</div>
        <div class="md-subheading">
          Edad: {{$moment().diff(paciente.fecha_nac_pac, 'years')}} años. Sexo: {{paciente.sexo_pac}}
        </div>
      </md-card-header>
      <md-card-content>
        <div class="tamizaje-form">
          <div class="md-layout md-gutter">
            <div class="md-layout-item md-xsmall-size-70 md-size-60 pt-2">
              <div
                class="md-subheading text-center"
                v-text="'Signos y síntomas'"
              />
            </div>
            <div class="md-layout-item md-xsmall-size-30 md-size-40">
              <div class="md-subheading text-center" />
            </div>
            <!-- <div class="md-layout-item md-xsmall-size-50 md-small-size-25 md-size-20"> <div class="md-subheading text-center">2da vez en el año </div> </div> -->
          </div>
          <div
            class="md-layout md-gutter"
            v-for="(item,index) in Object.keys(sintomas)"
            :key="item"
          >
            <div
              class="md-layout-item md-xsmall-size-70 md-size-60 brr "
              :class="index < 29 ? 'bbb':''"
            >
              <p>
                <md-icon
                  :class="sintomas[item].bg"
                  class="mr8"
                />
                {{sintomas[item].descripcion}}
              </p>
            </div>
            <div class="md-layout-item md-xsmall-size-30 md-size-40 bbb text-center">
              <md-radio
                v-model="sintomas[item].primeravez"
                :value="true"
              >Si</md-radio>
              <md-radio
                v-model="sintomas[item].primeravez"
                :value="false"
              >No</md-radio>
            </div>
            <!-- <div class="md-layout-item md-xsmall-size-25 md-small-size-25 md-size-20 text-center" :class="index < 29 ? 'bbb':''" > <md-radio v-model="sintomas[item].segundavez" :value="true" >Si</md-radio> <md-radio v-model="sintomas[item].segundavez" :value="false" >No</md-radio> </div> -->
          </div>
        </div>
      </md-card-content>
      <md-divider />
      <md-card-content class="mt16 lactancia-form">
        <div class="md-subheading">Parasitosis</div>
        <div class="md-layout md-gutter">
          <div class="md-layout-item md-size-100">
            <label>¿Hace cuánto tiempo se desparasitó al menor por última vez?</label><br>
            <md-radio
              v-model="preguntas.par_pregunta1"
              value="Nunca"
            >Nunca</md-radio>
            <md-radio
              v-model="preguntas.par_pregunta1"
              value="Menos de 6 meses"
            >Menos de 6 meses</md-radio>
            <md-radio
              v-model="preguntas.par_pregunta1"
              value="Entre 6 meses y 1 año"
            >Entre 6 meses y 1 año</md-radio>
            <md-radio
              v-model="preguntas.par_pregunta1"
              value="Más de 1 año"
            >Más de 1 año</md-radio>
          </div>
          <div class="md-layout-item md-size-100">
            <label>¿Ha tenido evacuaciones diarréicas en más de una ocasión en los últimos 3 meses?</label><br>
            <md-radio
              v-model="preguntas.par_pregunta2"
              value="SI"
            >SI</md-radio>
            <md-radio
              v-model="preguntas.par_pregunta2"
              value="NO"
            >NO</md-radio>
          </div>
          <div class="md-layout-item md-size-100">
            <label>3. ¿Ha tenido evacuaciones con moco en los últimos 3 meses?</label><br>
            <md-radio
              v-model="preguntas.par_pregunta3"
              value="SI"
            >SI</md-radio>
            <md-radio
              v-model="preguntas.par_pregunta3"
              value="NO"
            >NO</md-radio>
          </div>
          <div class="md-layout-item md-size-100">
            <label>¿Ha tenido evacuaciones con sangre en los últimos 3 meses?</label><br>
            <md-radio
              v-model="preguntas.par_pregunta4"
              value="SI"
            >SI</md-radio>
            <md-radio
              v-model="preguntas.par_pregunta4"
              value="NO"
            >NO</md-radio>
          </div>
          <div class="md-layout-item md-size-100">
            <label>¿El niño presenta prurito anal?</label><br>
            <md-radio
              v-model="preguntas.par_pregunta5"
              value="SI"
            >SI</md-radio>
            <md-radio
              v-model="preguntas.par_pregunta5"
              value="NO"
            >NO</md-radio>
          </div>
        </div>
        <div class="md-subheading mt24">Lactancia</div>
        <div class="md-layout md-gutter">
          <div class="md-layout-item md-size-100">
            <label>¿El menor recibió lactancia materna?</label><br>
            <md-radio
              v-model="preguntas.lac_pregunta1"
              value="SI"
            >SI</md-radio>
            <md-radio
              v-model="preguntas.lac_pregunta1"
              value="NO"
            >NO</md-radio>
          </div>
          <div
            class="md-layout-item md-size-100"
            v-if="preguntas.lac_pregunta1 === 'SI'"
          >
            <label>¿El menor fue amamantado dentro de la primera hora de nacimiento?</label><br>
            <md-radio
              v-model="preguntas.lac_pregunta2"
              value="SI"
            >SI</md-radio>
            <md-radio
              v-model="preguntas.lac_pregunta2"
              value="NO"
            >NO</md-radio>
          </div>
          <div
            class="md-layout-item md-size-100"
            v-if="preguntas.lac_pregunta1 === 'SI'"
          >
            <label>¿Hasta qué edad fue amamantado?</label><br>
            <md-radio
              v-model="preguntas.lac_pregunta3"
              value="Menos de 6 meses"
            >Menos de 6 meses</md-radio>
            <md-radio
              v-model="preguntas.lac_pregunta3"
              value="Entre 6 meses y 1 año"
            >Entre 6 meses y 1 año</md-radio>
            <md-radio
              v-model="preguntas.lac_pregunta3"
              value="Entre 1 año y 2 años"
            >Entre 1 año y 2 años</md-radio>
            <md-radio
              v-model="preguntas.lac_pregunta3"
              value="Más de 2 años."
            >Más de 2 años.</md-radio>
          </div>
          <div
            class="md-layout-item md-size-100"
            v-if="preguntas.lac_pregunta1 === 'SI'"
          >
            <label>¿Durante los 6 primeros meses de vida fue alimentado exclusivamente con lactancia materna?</label><br>
            <md-radio
              v-model="preguntas.lac_pregunta4"
              value="SI"
            >SI</md-radio>
            <md-radio
              v-model="preguntas.lac_pregunta4"
              value="NO"
            >NO</md-radio>
          </div>
        </div>
        <div
          class="md-subheading mt24"
          v-if="$session.get('dentistaEnEscuela') && $session.get('dentistaEnEscuela') === 'si'"
        >Dental</div>
        <div class="md-layout md-gutter">
          <div class="md-layout-item md-size-100">
            <label>¿Existen dientes con caries?</label><br>
            <md-radio
              v-model="preguntas.dent_pregunta1"
              value="SI"
            >SI</md-radio>
            <md-radio
              v-model="preguntas.dent_pregunta1"
              value="NO"
            >NO</md-radio>
          </div>
          <div class="md-layout-item md-size-100">
            <label>¿Existe pérdida de piezas dentales?</label><br>
            <md-radio
              v-model="preguntas.dent_pregunta2"
              value="SI"
            >SI</md-radio>
            <md-radio
              v-model="preguntas.dent_pregunta2"
              value="NO"
            >NO</md-radio>
          </div>
          <div class="md-layout-item md-size-100">
            <label>¿Existen dientes obturados?</label><br>
            <md-radio
              v-model="preguntas.dent_pregunta3"
              value="SI"
            >SI</md-radio>
            <md-radio
              v-model="preguntas.dent_pregunta3"
              value="NO"
            >NO</md-radio>
          </div>
          <div class="md-layout-item md-size-100">
            <label>¿ Existe alguna lesión de tejidos blandos en cavidad oral?</label><br>
            <md-radio
              v-model="preguntas.dent_pregunta4"
              value="SI"
            >SI</md-radio>
            <md-radio
              v-model="preguntas.dent_pregunta4"
              value="NO"
            >NO</md-radio>
          </div>
        </div>
      </md-card-content>
      <md-card-actions>
        <md-button to="/pacientes">Cancelar</md-button>
        <md-button
          class="md-primary md-raised"
          @click="_preSave()"
        >Guardar</md-button>
      </md-card-actions>
    </md-card>
    <md-dialog
      :md-active.sync="showDialogNextStep"
      :md-close-on-esc="false"
      :md-click-outside-to-close="false"
    >
      <md-dialog-title>¿A dónde deseas ir?</md-dialog-title>
      <md-list>
        <md-list-item to="/paciente">
          <md-icon class="md-primary">person</md-icon>
          <span class="md-list-item-text">Registrar paciente</span>
        </md-list-item>
        <md-divider />
        <md-list-item to="/pacientes">
          <md-icon class="md-primary">people_outline</md-icon>
          <span class="md-list-item-text">Ver pacientes</span>
        </md-list-item>
        <md-divider />
        <md-list-item to="/">
          <md-icon class="md-primary">home</md-icon>
          <span
            class="md-list-item-text"
            style="color:#121417"
          >Inicio</span>
        </md-list-item>
      </md-list>
    </md-dialog>
    <md-dialog
      :md-active.sync="showDialogJustifique"
      :md-close-on-esc="false"
      :md-click-outside-to-close="false"
    >
      <md-dialog-title>Marcaste uno o más signos de alarma positivos y decidiste NO referir. ¿Cuál es el motivo?</md-dialog-title>
      <md-dialog-content>
        <md-field>
          <label>Justifique su decisión</label>
          <md-textarea
            v-model="justificacion_tam"
            required
          ></md-textarea>
        </md-field>
      </md-dialog-content>
      <md-dialog-actions>
        <md-button @click="showDialogJustifique=false">Corregir decisión</md-button>
        <md-button
          :disabled="justificacion_tam.replace(/\s+/g, '').length>=10 ? false:true"
          class="md-primary md-raised"
          @click="_guardar"
        >Guardar</md-button>
      </md-dialog-actions>
    </md-dialog>
  </div>
</template>

<script>
export default {
  name: "TamizajeCuestionario",
  data() {
    return {
      paciente: {
        id: "",
        id_pac: "",
        nombre_pac: "",
        ape_pat_pac: "",
        ape_mat_pac: "",
        fecha_nac_pac: ""
      },
      sintomas: {
        sintoma1: {
          bg: "fondo-rojo",
          descripcion:
            "Fiebre mayor a 38°C, por más de 7 días sin causa aparente",
          primeravez: false,
          segundavez: false
        },
        sintoma2: {
          bg: "fondo-rojo",
          descripcion:
            "Dolor de cabeza, persistente y progresivo: de predominio nocturno, que despierta al menor o aparece al momento de levantarse y puede acompañarse de vómito",
          primeravez: false,
          segundavez: false
        },
        sintoma3: {
          bg: "fondo-rojo",
          descripcion:
            "Dolores óseas unilaterales que han aumentado progresivamente en el último mes e interrumpen su actividad",
          primeravez: false,
          segundavez: false
        },
        sintoma4: {
          bg: "fondo-rojo",
          descripcion:
            "Petequias, moretones, gingivorragias y/o sangrados sin expliación",
          primeravez: false,
          segundavez: false
        },
        sintoma5: {
          bg: "fondo-rojo",
          descripcion: "Palidez palmar o conjuntival severa",
          primeravez: false,
          segundavez: false
        },
        sintoma6: {
          bg: "fondo-rojo",
          descripcion: "Leucocoria (ojo blanco)",
          primeravez: false,
          segundavez: false
        },
        sintoma7: {
          bg: "fondo-rojo",
          descripcion: "Estrabismo que ha ido apareciendo",
          primeravez: false,
          segundavez: false
        },
        sintoma8: {
          bg: "fondo-rojo",
          descripcion:
            "Alteración en la visión (borrosa, doble o ceguera súbita)",
          primeravez: false,
          segundavez: false
        },
        sintoma9: {
          bg: "fondo-rojo",
          descripcion: "Aniridia (falta de iris)",
          primeravez: false,
          segundavez: false
        },
        sintoma10: {
          bg: "fondo-rojo",
          descripcion: "Hifema (Sangre en ojo) y/o Proptosis (ojo saltado)",
          primeravez: false,
          segundavez: false
        },
        sintoma11: {
          bg: "fondo-rojo",
          descripcion:
            "Ganglios > 2.5cm de diámetro, duros, no dolorosas, evolución > a 4 Semanas",
          primeravez: false,
          segundavez: false
        },
        sintoma12: {
          bg: "fondo-rojo",
          descripcion:
            "Convulsión sin fiebre ni enfermedad neurológica de base",
          primeravez: false,
          segundavez: false
        },
        sintoma13: {
          bg: "fondo-rojo",
          descripcion:
            "Debilidad unilateral (una de las extremidades o un lado del cuerpo)",
          primeravez: false,
          segundavez: false
        },
        sintoma14: {
          bg: "fondo-rojo",
          descripcion: "Asimetría física (facial)",
          primeravez: false,
          segundavez: false
        },
        sintoma15: {
          bg: "fondo-rojo",
          descripcion:
            "Cambios del estado de conciencia o mental (comportamiento, confusión)",
          primeravez: false,
          segundavez: false
        },
        sintoma16: {
          bg: "fondo-rojo",
          descripcion: "Pérdida del equilibrio al caminar",
          primeravez: false,
          segundavez: false
        },
        sintoma17: {
          bg: "fondo-rojo",
          descripcion: "Cojea por dolor",
          primeravez: false,
          segundavez: false
        },
        sintoma18: {
          bg: "fondo-rojo",
          descripcion: "Dificultad para hablar",
          primeravez: false,
          segundavez: false
        },
        sintoma19: {
          bg: "fondo-rojo",
          descripcion: "Masa palpable en abdomen, riñon, higado, bazo u ovario",
          primeravez: false,
          segundavez: false
        },
        sintoma20: {
          bg: "fondo-rojo",
          descripcion: "Hepatomegalia y/o esplenomegalia",
          primeravez: false,
          segundavez: false
        },
        sintoma21: {
          bg: "fondo-rojo",
          descripcion: "Crecimiento asimétrico testicular",
          primeravez: false,
          segundavez: false
        },
        sintoma22: {
          bg: "fondo-rojo",
          descripcion:
            "Masa en alguna región del cuerpo, extremidades o tronco",
          primeravez: false,
          segundavez: false
        },
        sintoma23: {
          bg: "fondo-amarillo",
          descripcion: "Pérdida de apetito en los últimos 3 meses",
          primeravez: false,
          segundavez: false
        },
        sintoma24: {
          bg: "fondo-amarillo",
          descripcion: "Pérdida de peso en los últimos 3 meses",
          primeravez: false,
          segundavez: false
        },
        sintoma25: {
          bg: "fondo-amarillo",
          descripcion: "Cansancio o fatiga en los últimos 3 meses",
          primeravez: false,
          segundavez: false
        },
        sintoma26: {
          bg: "fondo-amarillo",
          descripcion: "Sudoración nocturna importante, sin causa aparente",
          primeravez: false,
          segundavez: false
        },
        sintoma27: {
          bg: "fondo-amarillo",
          descripcion: "Palidez palmar o conjuntival leve",
          primeravez: false,
          segundavez: false
        },
        sintoma28: {
          bg: "fondo-amarillo",
          descripcion:
            "Linfadenopatía dolorosa o con evlolución < 4 semanas o con diámetro < 2.5cm o consistencia no dura",
          primeravez: false,
          segundavez: false
        },
        sintoma29: {
          bg: "fondo-amarillo",
          descripcion:
            "Aumenta de volumen en cualquier región del cuerpo con signos de inflamación",
          primeravez: false,
          segundavez: false
        },
        cumple_crit_cancer: {
          bg: "fondo-verde",
          descripcion: "Cumple criterios para sospechar cáncer",
          primeravez: false,
          segundavez: false
        }
      },
      preguntas: {
        par_pregunta1: null,
        par_pregunta2: null,
        par_pregunta3: null,
        par_pregunta4: null,
        par_pregunta5: null,
        lac_pregunta1: null,
        lac_pregunta2: null,
        lac_pregunta3: null,
        lac_pregunta4: null,
        dent_pregunta1: null,
        dent_pregunta2: null,
        dent_pregunta3: null,
        dent_pregunta4: null
      },
      errores: {
        par_pregunta1: null,
        par_pregunta2: null,
        par_pregunta3: null,
        par_pregunta4: null,
        par_pregunta5: null,
        lac_pregunta1: null,
        lac_pregunta2: null,
        lac_pregunta3: null,
        lac_pregunta4: null,
        dent_pregunta1: null,
        dent_pregunta2: null,
        dent_pregunta3: null,
        dent_pregunta4: null
      },
      justificacion_tam: "",
      pacientes: [],
      indexPaciente: null,
      showDialogNextStep: false,
      showDialogJustifique: false
    };
  },
  methods: {
    _isFine(a) {
      return a ? null : "md-invalid";
      //return 'md-invalid'
    },
    _validate() {
      this.errores.par_pregunta1 = this._isFine(this.preguntas.par_pregunta1);
      this.errores.par_pregunta2 = this._isFine(this.preguntas.par_pregunta2);
      this.errores.par_pregunta3 = this._isFine(this.preguntas.par_pregunta3);
      this.errores.par_pregunta4 = this._isFine(this.preguntas.par_pregunta4);
      this.errores.par_pregunta5 = this._isFine(this.preguntas.par_pregunta5);
      this.errores.lac_pregunta1 = this._isFine(this.preguntas.lac_pregunta1);
      if (
        this.preguntas.lac_pregunta1 === "SI" ||
        this.preguntas.lac_pregunta1 === "si"
      ) {
        this.errores.lac_pregunta2 = this._isFine(this.preguntas.lac_pregunta2);
        this.errores.lac_pregunta3 = this._isFine(this.preguntas.lac_pregunta3);
        this.errores.lac_pregunta4 = this._isFine(this.preguntas.lac_pregunta4);
      } else {
        this.errores.lac_pregunta2 = null;
        this.errores.lac_pregunta3 = null;
        this.errores.lac_pregunta4 = null;
      }
      if (
        this.$session.get("dentistaEnEscuela") &&
        this.$session.get("dentistaEnEscuela") === "si"
      ) {
        this.errores.dent_pregunta1 = this._isFine(
          this.preguntas.dent_pregunta1
        );
        this.errores.dent_pregunta2 = this._isFine(
          this.preguntas.dent_pregunta2
        );
        this.errores.dent_pregunta3 = this._isFine(
          this.preguntas.dent_pregunta3
        );
        this.errores.dent_pregunta4 = this._isFine(
          this.preguntas.dent_pregunta4
        );
      }
      console.dir(this.errores);
      return this.$validate(this.errores);
    },
    async _checkIfSintomasAreFine() {
      let a = false; //its false to check if something is true
      let b = false; //return false as "something is bad", return true as "alll is fine"
      let s = this.sintomas;
      Object.keys(this.sintomas).forEach(e => {
        if (e != "cumple_crit_cancer") {
          if (s[e].primeravez) a = true;
        } else {
          b = !s[e].primeravez ? !a : true;
        }
      });
      return b;
    },
    async _preSave() {
      console.log("presave");
      if (this._validate()) {
        if (await this._checkIfSintomasAreFine()) {
          this._guardar();
        } else {
          this.showDialogJustifique = true;
        }
      } else {
        this.$emit(
          "msg",
          "Responda todas las preguntas de parasitosis, lactancia y dental"
        );
      }
      /*
      if (
        this.sintomas.cumple_crit_cancer.primeravez === true ||
        this.sintomas.cumple_crit_cancer.segundavez === true
      ) {
        this.showDialogNextStep = true;
      } else {
        this.$router.push("/");
      }
      */
    },
    _guardar() {
      this.showDialogJustifique = false;
      let noww = "c." + this.$moment().format("YYYY-MM-DD HH:mm:ss");
      if (!this.pacientes[this.indexPaciente].hasOwnProperty("tamizajes")) {
        this.pacientes[this.indexPaciente]["tamizajes"] = [];
      }
      let idTemporal = "c." + Date.now().toString();
      let idPac = this.$route.params.idPac;
      this.pacientes[this.indexPaciente]["tamizajes"].push({
        id: noww,
        id_tam: noww,
        id_pac: idPac,
        created_tam: noww,
        justificacion_tam: this.justificacion_tam,
        sintoma1_1: {
          primeravez: this.sintomas.sintoma1.primeravez,
          segundavez: this.sintomas.sintoma1.segundavez
        },
        sintoma2_1: {
          primeravez: this.sintomas.sintoma2.primeravez,
          segundavez: this.sintomas.sintoma2.segundavez
        },
        sintoma3_1: {
          primeravez: this.sintomas.sintoma3.primeravez,
          segundavez: this.sintomas.sintoma3.segundavez
        },
        sintoma4_1: {
          primeravez: this.sintomas.sintoma4.primeravez,
          segundavez: this.sintomas.sintoma4.segundavez
        },
        sintoma5_1: {
          primeravez: this.sintomas.sintoma5.primeravez,
          segundavez: this.sintomas.sintoma5.segundavez
        },
        sintoma6_1: {
          primeravez: this.sintomas.sintoma6.primeravez,
          segundavez: this.sintomas.sintoma6.segundavez
        },
        sintoma7: {
          primeravez: this.sintomas.sintoma7.primeravez,
          segundavez: this.sintomas.sintoma7.segundavez
        },
        sintoma8: {
          primeravez: this.sintomas.sintoma8.primeravez,
          segundavez: this.sintomas.sintoma8.segundavez
        },
        sintoma9: {
          primeravez: this.sintomas.sintoma9.primeravez,
          segundavez: this.sintomas.sintoma9.segundavez
        },
        sintoma10: {
          primeravez: this.sintomas.sintoma10.primeravez,
          segundavez: this.sintomas.sintoma10.segundavez
        },
        sintoma11: {
          primeravez: this.sintomas.sintoma11.primeravez,
          segundavez: this.sintomas.sintoma11.segundavez
        },
        sintoma12: {
          primeravez: this.sintomas.sintoma12.primeravez,
          segundavez: this.sintomas.sintoma12.segundavez
        },
        sintoma13: {
          primeravez: this.sintomas.sintoma13.primeravez,
          segundavez: this.sintomas.sintoma13.segundavez
        },
        sintoma14: {
          primeravez: this.sintomas.sintoma14.primeravez,
          segundavez: this.sintomas.sintoma14.segundavez
        },
        sintoma15: {
          primeravez: this.sintomas.sintoma15.primeravez,
          segundavez: this.sintomas.sintoma15.segundavez
        },
        sintoma16: {
          primeravez: this.sintomas.sintoma16.primeravez,
          segundavez: this.sintomas.sintoma16.segundavez
        },
        sintoma17: {
          primeravez: this.sintomas.sintoma17.primeravez,
          segundavez: this.sintomas.sintoma17.segundavez
        },
        sintoma18: {
          primeravez: this.sintomas.sintoma18.primeravez,
          segundavez: this.sintomas.sintoma18.segundavez
        },
        sintoma19: {
          primeravez: this.sintomas.sintoma19.primeravez,
          segundavez: this.sintomas.sintoma19.segundavez
        },
        sintoma20: {
          primeravez: this.sintomas.sintoma20.primeravez,
          segundavez: this.sintomas.sintoma20.segundavez
        },
        sintoma21: {
          primeravez: this.sintomas.sintoma21.primeravez,
          segundavez: this.sintomas.sintoma21.segundavez
        },
        sintoma22: {
          primeravez: this.sintomas.sintoma22.primeravez,
          segundavez: this.sintomas.sintoma22.segundavez
        },
        sintoma23: {
          primeravez: this.sintomas.sintoma23.primeravez,
          segundavez: this.sintomas.sintoma23.segundavez
        },
        sintoma24: {
          primeravez: this.sintomas.sintoma24.primeravez,
          segundavez: this.sintomas.sintoma24.segundavez
        },
        sintoma25: {
          primeravez: this.sintomas.sintoma25.primeravez,
          segundavez: this.sintomas.sintoma25.segundavez
        },
        sintoma26: {
          primeravez: this.sintomas.sintoma26.primeravez,
          segundavez: this.sintomas.sintoma26.segundavez
        },
        sintoma27: {
          primeravez: this.sintomas.sintoma27.primeravez,
          segundavez: this.sintomas.sintoma27.segundavez
        },
        sintoma28: {
          primeravez: this.sintomas.sintoma28.primeravez,
          segundavez: this.sintomas.sintoma28.segundavez
        },
        sintoma29: {
          primeravez: this.sintomas.sintoma29.primeravez,
          segundavez: this.sintomas.sintoma29.segundavez
        },
        cumple_crit_cancer: {
          primeravez: this.sintomas.cumple_crit_cancer.primeravez,
          segundavez: this.sintomas.cumple_crit_cancer.segundavez
        },
        par_pregunta1: this.preguntas.par_pregunta1,
        par_pregunta2: this.preguntas.par_pregunta2,
        par_pregunta3: this.preguntas.par_pregunta3,
        par_pregunta4: this.preguntas.par_pregunta4,
        par_pregunta5: this.preguntas.par_pregunta5,
        lac_pregunta1: this.preguntas.lac_pregunta1,
        lac_pregunta2: this.preguntas.lac_pregunta2,
        lac_pregunta3: this.preguntas.lac_pregunta3,
        lac_pregunta4: this.preguntas.lac_pregunta4,
        dent_pregunta1: this.preguntas.dent_pregunta1,
        dent_pregunta2: this.preguntas.dent_pregunta2,
        dent_pregunta3: this.preguntas.dent_pregunta3,
        dent_pregunta4: this.preguntas.dent_pregunta4
      });
      this.$emit("msg", "Tamizaje guardado");
      this.showDialogNextStep = true;
    }
  },
  created() {
    let idPac = this.$route.params.idPac;
    this.pacientes = JSON.parse(localStorage.getItem("pacientes"));
    this.indexPaciente = this.pacientes.findIndex(function(b) {
      return b.id === idPac;
    });
    if (this.indexPaciente >= 0) {
      this.paciente = this.pacientes[this.indexPaciente];
    } else {
      this.$emit("msg", "Paciente no encontrado");
      this.$router.push("/pacientes");
    }
  },
  beforeCreate() {
    if (!this.$session.exists() && !this.$session.get("tipo")) {
      this.$emit("visible", false);
      this.$router.push("/login");
    } else {
      this.$emit("visible", true);
      this.$emit("classes", "container");
    }
  },
  beforeDestroy() {
    localStorage.setItem("pacientes", JSON.stringify(this.pacientes));
  }
};
</script>
<style>
.tamizaje-form {
  padding: 0 4px;
}
</style>